import * as PIXI from "pixi.js";
import Layers from "../../../layers/Layers";
import TopButton from "./TopButton";
import { TopButtonProps, TopSwitcherOptions, TopSwitcherProps } from "../../../types/Interface";
import addInteractivity from "../../../utils/addInteractivity";
import { CustomCursorType } from "../CustomCursor/CustomCursor";


export default class TopSwitcherRenderer extends PIXI.Container {
  private Layers = Layers.getInstance();
  private bg = this.addChild(new PIXI.Graphics());
  buttons: TopButton[] = [];

  constructor(TopSwitcherProps: TopSwitcherProps, con?: PIXI.Container, private options?: TopSwitcherOptions) {
    super()
    this.addButtons(TopSwitcherProps.eventBusName, TopSwitcherProps.topButtonsProps);
    this.drawBg();
    this.addToCon(con);
    this.disactiveEventMode();
    this.x = 100;
    this.y = 100;
  }
  private addToCon = (con?: PIXI.Container) => con ? con.addChild(this) : this.Layers.UITop.addChild(this);
  private drawBg() {
    const firstButton = this.buttons[0].TopButtonRenderer;
    const lastButton = this.buttons[this.buttons.length - 1].TopButtonRenderer;
    const _wHalf = firstButton.width / 2;
    const _w1 = firstButton.x - _wHalf;
    const _w2 = lastButton.x + lastButton.width / 2;
    const h = firstButton.height;
    const bgColor = this.options?.bgColor || 0xFFFFFF;

    this.bg
      .roundRect(_w1 - 15, -h / 2 - 4, _w2 + _wHalf + 30, h + 8, 10)
      .fill(bgColor);
    if (this.options?.borderStyle) {
      const { width, color } = this.options.borderStyle;
      this.bg.stroke({ width, color });
    }
    addInteractivity(this.bg, {}, CustomCursorType.default)
  }
  private addButtons(eventBusName: string, TopButtonsProps: TopButtonProps[]) {
    TopButtonsProps.forEach(topButton => {
      const button = new TopButton(eventBusName, topButton.label, topButton.onHandleDownFunc, this.options);
      this.addChild(button.TopButtonRenderer);
      this.buttons.push(button);
    });

    this.buttons.forEach((button, bI) => {
      if (bI == 0) return;
      const prevButton = this.buttons[bI - 1].TopButtonRenderer;
      const xCoord = prevButton.x + prevButton.width / 2 + button.TopButtonRenderer.width / 2 + 10;
      button.TopButtonRenderer.x = xCoord;
    })
  }
  disactiveEventMode = () => this.bg.eventMode = "none";
}